import Cookies from 'js-cookie'

const OpenidKey = 'openid'

export function getOpenid() {
  return Cookies.get(OpenidKey)
}

export function setOpenid(openid) {
  return Cookies.set(OpenidKey, openid)
}

export function removeOpenid() {
  return Cookies.remove(OpenidKey)
}
